import { recordingPaused } from "redux/actions/RecordingStatusAction";
import { constants } from "../constants/redux-constants";

const initialState = {
  isRecording: false,
  recordingStopped: false,
  recordingPaused: false,
};

const recordingStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RECORDING_STATUS:
      return {
        ...state,
        isRecording: action.payload,
      };
    case constants.RECORDING_STOPPED:
      return {
        ...state,
        recordingStopped: action.payload,
        recordingPaused: action.payload ? false : state?.recordingPaused,
      };
    case constants.RECORDING_PAUSED:
      return {
        ...state,
        recordingPaused: action.payload,
      };
    case constants.RECODING_DRAFT:
      return {
        ...state,
        recordingDraft: action.payload,
      };
    default:
      return state;
  }
};

export default recordingStatusReducer;
